import '@niarab2c/frontend-commons/src/checkUpdate';
import '@niarab2c/frontend-commons/src/polyfills';
import 'regenerator-runtime/runtime';
import { startInitAppDebugOverlay } from '@niarab2c/frontend-commons/src/util/initAppDebugOverlay';
import { emitInitAppDebugEvent } from '@niarab2c/frontend-commons/src/util/initAppDebugEvents';
startInitAppDebugOverlay();
emitInitAppDebugEvent('index1:loaded', 'ok');
import('./scss/index.scss');
import('@niaratech/niara-react-components/scss/index.scss');
emitInitAppDebugEvent('index2:loading', 'ok');
import('./index2');
emitInitAppDebugEvent('sentry:loading', 'ok');
import('@niarab2c/niarab2c-core/src/sentry/init').then(({
  default: init
}) => init?.());